import { createFileRoute } from "@tanstack/react-router";

import { startReaderPatreonFlow } from "@/lib/api";

export const Route = createFileRoute("/app/connect/patreon")({
  beforeLoad: startReaderPatreonFlow,
});
